import { ArrowLeftBigIcon } from '../../icons/arrowLeftBig';
import { ArrowRightIcon } from '../../icons/arrowRight';
import { PaginationItemType } from './model';

export const pageTypeToIcon: Partial<Record<PaginationItemType, React.FC>> = {
  previous: ArrowLeftBigIcon,
  next: ArrowRightIcon,
};
